import { actions } from './physiotherapyIndex/actions'
import { getters } from './physiotherapyIndex/getters'
import { state } from './physiotherapyIndex/state'
import { mutations } from './physiotherapyIndex/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
